/**
 * Pagina de callback OAuth.
 * Recibe el token o error del backend via query params y completa el login.
 */
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { completeOAuthLogin } from '../lib/auth';

export default function OAuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError(errorParam);
      return;
    }

    if (!token) {
      setError('No se recibio un token de autenticacion');
      return;
    }

    completeOAuthLogin(token).then((result) => {
      if (result.success && result.user) {
        const dest = result.user.tipo === 'CLIENTE' ? '/portal' : '/';
        navigate(dest);
      } else {
        setError(result.error || 'Error completando la autenticacion OAuth');
      }
    });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="max-w-md w-full">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-blue-600 mb-2">QOps</h1>
          </div>
          <div className="bg-white rounded-lg shadow-md p-8">
            <div className="mb-4 p-3 bg-red-100 border border-red-300 text-red-700 rounded">
              {error}
            </div>
            <button
              onClick={() => navigate('/login')}
              className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-md transition duration-200"
            >
              Volver al login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-blue-600 mb-4">QOps</h1>
        <p className="text-gray-600">Completando inicio de sesion...</p>
      </div>
    </div>
  );
}
